import { render, staticRenderFns } from "./addPackage.vue?vue&type=template&id=5197a104&scoped=true"
import script from "./addPackage.vue?vue&type=script&lang=js"
export * from "./addPackage.vue?vue&type=script&lang=js"
import style0 from "./addPackage.vue?vue&type=style&index=0&id=5197a104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197a104",
  null
  
)

export default component.exports